import request from './';

// wrap a jquery xhr with a Promise and some error handler behaviour
export default function wrapJQueryRequest(req: JQueryXHR) {
  return Promise.resolve(req)
    .catch((res) => Promise.reject(new request.RequestError(res)))
    .catch(request.handleGenericAppErrors);
}
